import React from 'react'

const ReviewProcess = () => {
  return (
    <div>
      <p>
        The <b>International Journal of Innovative Studies in Social Sciences (IJISSS)</b> 
        follows a <b>rigorous multi-stage peer-review process</b> to ensure research 
        quality, academic integrity, and scholarly credibility.
      </p>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Initial Screening</h4>
      <ul>
        <li>All submissions undergo plagiarism detection using advanced screening tools.</li>
        <li>
          The editorial board evaluates manuscripts for quality, relevance to the journal’s scope, 
          originality, and adherence to ethical standards.
        </li>
        <li>
          Manuscripts that do not meet basic requirements are declined prior to external review.
        </li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Peer-Review Assignment</h4>
      <ul>
        <li>The <b>double-blind peer-review</b> process is initiated.</li>
        <li>
          A minimum of two qualified reviewers in the relevant field assess the manuscript independently.
        </li>
        <li>
          Reviewers submit constructive comments and recommendations within 2–4 weeks.
        </li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Author Revisions</h4>
      <ul>
        <li>
          If revisions are required, authors must resubmit an updated manuscript within the specified deadline.
        </li>
        <li>
          A detailed, point-by-point response letter addressing reviewer feedback is mandatory.
        </li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Editorial Decision</h4>
      <ul>
        <li>
          The editor reviews the referee reports and the revised manuscript to make the final decision.
        </li>
        <li>
          Possible outcomes include: <b>Accept</b>, <b>Minor Revision</b>, <b>Major Revision</b>, or <b>Reject</b>.
        </li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Final Proof & Publication</h4>
      <ul>
        <li>Accepted manuscripts undergo final proofreading and formatting for publication.</li>
        <li>DOI and indexing metadata are generated and assigned to each article.</li>
        <li>
          The article is published online under the journal’s <b>open-access policy</b>, 
          ensuring global accessibility.
        </li>
      </ul>

      <p>
        IJISSS maintains a transparent and ethical review system that supports high-quality 
        scholarly contributions in the field of social sciences.
      </p>
    </div>
  )
}

export default ReviewProcess
